import React from 'react';
import Layout from '../components/Layout';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex flex-col items-center justify-center py-32">
        <h1 className="text-6xl font-light text-gray-300 mb-4">404</h1>
        <h2 className="text-2xl text-gray-600 font-light mb-2">Page Not Found</h2>
        <p className="text-gray-500 mb-8">The page you're looking for doesn't exist yet.</p>
        <button
          onClick={() => navigate(-1)}
          className="bg-[#4ECFDB] hover:bg-[#3AB8C5] text-white px-6 py-2 rounded transition-colors"
          data-testid="go-back-btn"
        >
          Go Back
        </button>
      </div>
    </Layout>
  );
};

export default NotFound;
